import React, { Component } from "react";
import Loader from "../../general/Loader";
import { formatCurrency } from "../../../utils/helpers";
import Pagination from "../../general/Pagination";
import { withRequest } from "../../../utils/request";
import dayjs from "dayjs";
import { debounce } from "lodash";

class Gastos extends Component {
    state = {
        gastos: [],
        meta: false,
        links: false,
        loading: true,
        filtrosQuery: "",
        filtros: [],
    };
    componentDidMount() {
        this.getGastos();
    }
    getGastos = async (url = null) => {
        const id = this.props.item.id;
        url = url ? url : `gastos?item=${id}&limit=20`;
        const gastos = await this.props.request(url);

        if (gastos.data && gastos.data.length > 0) {
            this.setState({
                gastos: gastos.data,
                meta: gastos.meta,
                links: gastos.links,
                loading: false,
            });
        }

        this.setState({ loading: false });
    };

    onFiltroChange = debounce(async (value, filtro) => {
        await this.setState({
            filtros: {
                ...this.state.filtros,
                [filtro]: value,
            },
        });

        this.getGastosFiltrados();
    }, 500);

    getGastosFiltrados = async () => {
        let query = Object.keys(this.state.filtros).map((fil) => {
            return `${fil}=${this.state.filtros[fil]}`;
        });

        await this.setState({
            filtrosQuery: "?" + query.join("&"),
        });

        this.getGastos("gastos?limit=20&" + query.join("&"));
    };

    render() {
        const { gastos, meta, links } = this.state;
        const { loading } = this.state;

        if (loading === true) {
            return <Loader />;
        }
        return (
            <div>
                <div className='page-controls'>
                    <div className='table-data__tool'>
                        <div className='table-data__tool-left row'>
                            <div className='col-md-6'>
                                <label htmlFor='desde'>Desde</label>
                                <input
                                    type='date'
                                    name='desde'
                                    id='desde'
                                    defaultValue={dayjs()
                                        .startOf("day")
                                        .format("YYYY-MM-DD")}
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "desde"
                                        )
                                    }
                                />
                            </div>
                            <div className='col-md-6'>
                                <label htmlFor='hasta'>Hasta</label>
                                <input
                                    type='date'
                                    name='hasta'
                                    id='hasta'
                                    defaultValue={dayjs()
                                        .endOf("day")
                                        .format("YYYY-MM-DD")}
                                    className='form-control'
                                    onChange={(e) =>
                                        this.onFiltroChange(
                                            e.target.value,
                                            "hasta"
                                        )
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {gastos.length > 0 ? (
                    <table className='table tickets-table'>
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Vehículo</th>
                                <th>Precio/UND</th>
                                <th>Cantidad</th>
                            </tr>
                        </thead>
                        <tbody>
                            {gastos.map(gasto => (
                                <tr key={gasto.id}>
                                    <td>{gasto.fecha}</td>
                                    <td>{gasto.vehiculo}</td>
                                    <td>{formatCurrency(gasto.precio)}</td>
                                    <td>{gasto.cantidad}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div>No se han registrado gastos de este item.</div>
                )}
                {meta && (
                    <Pagination
                        links={links}
                        meta={meta}
                        getData={this.getGastos}
                    />
                )}
            </div>
        );
    }
}

export default withRequest(Gastos);
